import type { BodyRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/transactions/{id}/checkout']['post']['responses']['200']['content']['application/json'];
type TransactionCheckoutRequestBody =
  paths['/v3/transactions/{id}/checkout']['post']['requestBody']['content']['application/json'];
type TransactionCheckoutRouteParams = paths['/v3/transactions/{id}/checkout']['post']['parameters']['path'];

export const checkoutTransaction = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<TransactionCheckoutRequestBody, TransactionCheckoutRouteParams>) =>
  apiClient.post<ResponseType, ApiClientResponse<ResponseType>>(routes.transactions.checkout(id), body);
